import * as React from 'react';
import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Icon from '../common/Icon';
import { SupportedIcons } from '../common/Icon';
import clsx from 'clsx';
import { NavigationContext } from '../_navigation/NavigationContext';
import { Link } from 'react-router-dom';
import { useContext, useState } from 'react';
import { AuthContext } from '../_auth/AuthContext';
import { useHistory, useLocation } from 'react-router-dom';
import { IPermissionChecker } from '../_types/user';

interface Props {
    classes?: any,
    children?: any,
    path: string,
    iconName?: SupportedIcons | null,
    label: string,
    menuKey: string,
    showIcon?: boolean,
    groupKey: string,
    checkPermission?: IPermissionChecker
};



const useStyles = makeStyles((theme: Theme) =>
createStyles({
    menuItem: {
      fontWeight: "bold",
      textDecoration: "none",
      color: theme.palette.primary.dark
    },
    menuItemSelected: {
      extend: 'menuItem',
      fontStyle: 'italic'
    }

  })
);

const NavItem: React.FC<Props> = (props: Props) => {

    const { user, setUser } = useContext(AuthContext);
    const { nav } = useContext(NavigationContext);
    const [display, setDisplay ] = useState(false);
    const [selected , setSelected ] = useState(false);

    const history = useHistory();
    const classes = useStyles();

    let currentLocation = useLocation();
 

    const amISelected = (location: any) => {

      let requestedPath = location.pathname;
      let withoutParams: string = location.pathname;
      let parts = withoutParams.split('/');
      parts.pop();
      withoutParams = parts.join('/');
 

      let propsPath = props.path;

      // //i'm absolutely positive there's a better way to do this;
      // if (id !== undefined) {
      //   requestedPath = requestedPath.replace(id, '');
      //   propsPath += "/";

      // }
    
      setSelected(propsPath === requestedPath || propsPath === withoutParams);

    }

    const _shouldDisplay = () => {
      
      if (props.checkPermission) {
        props.checkPermission(user, setUser).then(r => {

          if (r) {
            let parentMenu = nav.openMenus.find(e => e.key === props.groupKey);
            r = parentMenu.open;
            
          }

          setDisplay(r);
        });
      } else {
        setDisplay(true);
      }
      

    }

    React.useEffect(() => {
      return history.listen((location) => {
        


        amISelected(location);
                
      })
    }, [history])

    React.useEffect(() => {
      
        _shouldDisplay();
      
        amISelected(currentLocation);
      
    }, []);

    React.useEffect(() => {
      
     _shouldDisplay();

    
    },[nav]);

    //const theme = useTheme();

    const GetIcon = (props: Props) => {
      if (props.iconName) {
        return (<ListItemIcon><Icon iconName={props.iconName}/></ListItemIcon>);
      } else {
        return (<span/>);
      }
    }


    return user.authorized && (display) ? (
    
          <Link to={props.path} style={{textDecoration: 'none'}}>
            <ListItem button key={props.menuKey}>
                {(props.showIcon===undefined || props.showIcon) && GetIcon(props) }
                <ListItemText className={clsx(classes.menuItem, selected && classes.menuItemSelected )} primary={props.label}>{props.label}</ListItemText>
                
            </ListItem>
          </Link>
  
    ): ( <div/> )
    //          { (selected && !props.subMenu) ? <Divider/> : "" }
};

export default NavItem;
